import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { RequisitionData } from '@core/tellent-assistant-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

type RequisitionStatus = RequisitionData['status'];

const requisitionStatusTranslationKeys: Record<RequisitionStatus, string> = {
  draft: 'app.requisitions.status.draft',
  pending: 'app.requisitions.status.pending',
  rejected: 'app.requisitions.status.rejected',
  approved: 'app.requisitions.status.approved',
  filled: 'app.requisitions.status.filled',
};

@Component({
  selector: 'rt-list-item-requisition',
  imports: [ListCardComponent, IconContainerComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-requisition.component.html',
  styleUrl: './list-item-requisition.component.less',
})
export class ListItemRequisitionComponent {
  private readonly i18n = inject(I18nService);

  protected readonly statusLabel = computed(() =>
    this.i18n.translate(requisitionStatusTranslationKeys[this.data().status]),
  );

  public readonly data = input.required<RequisitionData>();
}
